module.exports = __webpack_public_path__ + "media/images/bg/mosaic/dinner-033983cf981ba4b4e21e79aa4df01b9a.jpg";